import type { TripView } from '@voll-intelligence/domain';
import { VoucherDocument } from '@voll-intelligence/intelligence-ui-kit';
import { buildVoucherDocumentView, tripServices } from '@voll-intelligence/trip-panel';
import { copyText } from '@voll-intelligence/trip-panel/clipboard';
import { voucherCopy } from '@voll-intelligence/trip-panel/voucher_copy';

/** The service of a trip a `TripItinerary` step points at, or `undefined`. */
export function tripServiceOf(
  trip: TripView,
  serviceKey: string | null,
): ReturnType<typeof tripServices>[number] | undefined {
  return serviceKey ? tripServices(trip).find((s) => s.key === serviceKey) : undefined;
}

/**
 * O voucher de um serviço da viagem, read-only. É o mesmo `VoucherDocument` do
 * intelligence-ui-kit que o viajante vê no app — sem cancelar/mover/compartilhar (essas ações são
 * do web-chat). A raiz `.genui2` é obrigatória: o documento e o encaixe `fit="panel"`
 * são utilitárias do DS escopadas nela. O `Drawer` do console já é a superfície (fundo,
 * borda, sombra), então o documento entra sem a própria moldura de card.
 *
 * Molécula: quem a mostra (coluna de viagem do card, linha expandida dos alertas) a
 * compõe dentro do `Drawer` do console — um organismo não compõe outro.
 */
export function TripVoucherDocument({
  service,
  onClose,
}: Readonly<{
  service: NonNullable<ReturnType<typeof tripServiceOf>>;
  onClose: () => void;
}>): React.JSX.Element {
  return (
    <div className="genui2 flex h-full min-h-0 flex-col">
      <VoucherDocument
        view={buildVoucherDocumentView(service)}
        fit="panel"
        copy={voucherCopy()}
        writeClipboard={copyText}
        onClose={onClose}
      />
    </div>
  );
}
